var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProfile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0m0 3.83a2.38 2.38 0 1 1 0 4.76 2.38 2.38 0 1 1 0-4.76M10 16c-2.26 0-4.23-1.26-5.25-3.1.99-1.91 2.95-3.22 5.25-3.22s4.26 1.31 5.25 3.22A6.01 6.01 0 0 1 10 16"
})));
export default SvgProfile;